<template>
    <div class="ncrypt-message">
        <div v-if="message">
            <ion-grid class="ion-no-padding">
                <ion-row>
                    <ion-col size-xs="12">
                        <ion-list lines="none" inset="false" style="margin-bottom: 0;">
                            <ion-item class="ion-no-padding">
                                <ion-text>
                                    <h4>{{ message ? message.subject : '' }}</h4>
                                </ion-text>

                                <ion-chip slot="end" outline="true">
                                    <ion-icon ios='calendar' md="calendar"></ion-icon>

                                    <ion-label>{{ message.sent_at_short }}</ion-label>
                                </ion-chip>
                            </ion-item>

                            <ion-item class="ion-no-padding">
                                <ion-note slot="start">{{ $t('ncrypt.write_message.sender_from_label') }}</ion-note>

                                <message-participant :participant="message.sender"/>
                            </ion-item>

                            <ion-item class="ion-no-padding">
                                <ion-note slot="start">{{ $t('ncrypt.write_message.recipient_to_label') }}</ion-note>

                                <message-participant :participant="recipient" v-for="recipient in message.recipients" v-bind:key="recipient.id"/>
                            </ion-item>
                        </ion-list>
                    </ion-col>
                </ion-row>
            </ion-grid>

            <ion-item v-if="message.is_retracted" color="danger">
                <ion-text v-if="isOutbox">{{ $t('ncrypt.outbox.message_is_retracted') }}</ion-text>

                <ion-text v-else>{{ $t('ncrypt.inbox.message_is_retracted') }}</ion-text>
            </ion-item>

            <div v-if="!message.is_retracted || isOutbox">
                <ion-card>
                    <ion-card-header>
                        <ion-card-title>{{ $t('ncrypt.message_body_title') }}</ion-card-title>
                    </ion-card-header>
                    <ion-card-content v-dompurify-html="message ? message.body : ''"></ion-card-content>
                </ion-card>

                <ion-item lines="none" v-if="message.attachments.length">
                    <attachment v-for="attachment in message.attachments" v-bind:key="attachment.id" :attachment="attachment" outline color="primary"></attachment>
                </ion-item>
            </div>
        </div>

        <message-skeleton v-else/>
    </div>
</template>

<script>
    import Attachment from "../Attachment";
    import MessageParticipant from "./MessageParticipant";
    import MessageSkeleton from "./MessageSkeleton";
    import {MessageBoxType} from "../../const/MessageBoxType";

    export default {
        name: "Message",
        components: {MessageSkeleton, MessageParticipant, Attachment},
        props: {
            message: {type: Object},
            isRecipient: {type: Boolean, default: false},
            isHistory: {type: Boolean, default: false},
        },
        computed: {
            currentUserIsSender() {
                return this.message && this.$store.getters.authed && this.message.sender.id === this.$store.getters.user.id;
            },
            isOutbox() {
                return this.$route.query.boxType === MessageBoxType.OUTBOX;
            },
        },
    }
</script>
